export const base64ToFile = (data: string, fileName: string, mimeType: string) => {
    return fetch(data)
        .then((result) => result.blob())
        .then((blob) => {
            return new File([blob], fileName, { type: mimeType });
        })
}